import { Button, DropdownList, Table, TableData, TableRow } from '@cokitchen/cokitchen-components';
import { DeliveryManagmentPolygonType } from 'models/polygon.model';
import React, { useEffect, useState } from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import { BackIcon, DeleteIcon, EditAltIcon, MenuVerticalIcon } from 'cokitchen-icons';
import { ReactComponent as RecycleSettingsIcon } from 'assets/icons/recycle-settings.svg';
import { Dropdown, DropdownItem } from '@cokitchen/cokitchen-components';
import GeneralSurgeModal from 'components/logistics/surge/general';
import { ActiveGeneralSurgeType } from 'models/surge.model';
import { LOGISTICS_ROUTE_KEYS } from 'utils/constants';
import { Link, useNavigate } from 'react-router-dom';
import { apiService } from 'utils/api';
import { handleApiError } from 'utils/functions';

const TABLE_HEADERS = ['No', 'Polygon', 'Cokitchen', 'Delivery Partner', 'Action'];
const DeliveryManagmentTable = () => {
  const [pageCount, setPageCount] = useState(1);
  const [pageSize, setPageSize] = useState(1);
  const [loading, setLoading] = useState(false);
  const [generalSurgeModal, setGeneralSurgeModal] = useState(false);

  const [polygons, setPolygons] = useState<DeliveryManagmentPolygonType[]>([]);

  const { activeCokitchen, setSelectedPolygonLogisticsConfig, selectedPolygonLogisticsConfig } =
    useDashboardContext();

  const getSelectedPage = (val: { selected: number }) => {
    const pageNo = val?.selected + 1;
    setPageCount(pageNo);
  };
  const navigate = useNavigate();
  const [generalSurge] = useState<ActiveGeneralSurgeType>({
    id: '',
    logistics_surge: '',
    logistics_surge_type: ''
  });

  const handleDeletePolygon = async (id: string) => {
    navigate(LOGISTICS_ROUTE_KEYS.LOCATION, { state: { polygonId: id, type: 'delete' } });
  };

  const handleEditPolygon = async (id: string) => {
    navigate(LOGISTICS_ROUTE_KEYS.LOCATION, { state: { polygonId: id, type: 'edit' } });
  };

  const getPolygonData = async () => {
    setLoading(true);
    try {
      const res = await apiService.get(`cokitchen/${activeCokitchen.id}/polygon`, {
        baseUrl: process.env.REACT_APP_BRAND_MGT_API_URL,
        params: {
          page: pageCount,
          size: '12'
        }
      });
      if (res.data.data) {
        setPolygons(res.data.data?.data);
        setPageSize(
          Math.ceil(res.data.data?.pagination?.total / res.data.data?.pagination?.current_page)
        );
      }
    } catch (e) {
      handleApiError(e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getPolygonData();
  }, [pageCount]);
  return (
    <div>
      <section className=' flex justify-between items-center gap-10 mb-8 '>
        <div>
          <Link
            to={LOGISTICS_ROUTE_KEYS.OVERVIEW}
            className='inline-flex gap-1 items-center text-gray-8 text-sm font-medium'>
            <BackIcon /> Back to overview
          </Link>
          <h2 className='text-2xl font-semibold'>Polygons</h2>
        </div>
        <div>
          <Button
            size='small'
            variant='block'
            color='primary'
            onClick={() => {
              setGeneralSurgeModal(true);
              setSelectedPolygonLogisticsConfig({
                ...(selectedPolygonLogisticsConfig as any),
                bulkUpdate: true
              });
            }}
            className='!bg-black !text-white !rounded flex gap-2 !border-none'>
            <RecycleSettingsIcon />
            Manage all
          </Button>
        </div>
      </section>
      <section className='no-scroll-bar whitespace-nowrap pb-10  '>
        <Table
          loading={loading}
          headers={TABLE_HEADERS}
          onPageChange={getSelectedPage}
          pageCount={pageSize}>
          {polygons?.map((item, idx) => (
            <TableRow key={idx}>
              <TableData>
                <p>{idx + 1}</p>
              </TableData>
              <TableData className='px-5 text-gray-5 capitalize'>
                <p>{item.name}</p>
              </TableData>
              <TableData>
                <p>{activeCokitchen.name}</p>
              </TableData>
              <TableData>
                <div className='flex gap-2 items-center  overflow-x-scroll w-fit'>
                  {item?.logistics_config?.config.map((f, index) => (
                    <p
                      key={index}
                      className='capitalize text-xs bg-[#F2F2F3] text-[#595959] rounded-full px-2 py-1'>
                      {f.name === 'chowdeck-relay' ? 'Chowdeck' : f.name}
                    </p>
                  ))}
                </div>
              </TableData>
              <TableData className='px-5 text-gray-5 '>
                <button
                  onClick={() => {
                    setGeneralSurgeModal(!generalSurgeModal);
                    setSelectedPolygonLogisticsConfig({
                      ...(selectedPolygonLogisticsConfig as any),
                      polygonId: item.id,
                      logisticsConfig: item.logistics_config
                    });
                  }}
                  className='text-red-5 text-left underline underline-offset-2 cursor-pointer'>
                  Manage
                </button>
              </TableData>

              <TableData className='flex items-center gap-3'>
                <>
                  <Dropdown content={<MenuVerticalIcon />}>
                    <DropdownList className='max-h-[300px] min-w-[200px]'>
                      <DropdownItem key={idx} onClick={() => handleEditPolygon(item.id)}>
                        <div className='flex items-center gap-2'>
                          <EditAltIcon />
                          <p>Edit Polygon</p>
                        </div>
                      </DropdownItem>
                      <DropdownItem onClick={() => handleDeletePolygon(item.id)}>
                        <div className='flex items-center gap-2'>
                          <DeleteIcon className='text-red-5' />
                          <p className='text-red-5 '>Delete Polygon</p>
                        </div>
                      </DropdownItem>
                    </DropdownList>
                  </Dropdown>
                </>
              </TableData>
            </TableRow>
          ))}
        </Table>
        <GeneralSurgeModal
          show={generalSurgeModal}
          onClose={() => {
            setGeneralSurgeModal(false);
            getPolygonData();
          }}
          // defaultActiveTab='Fleets'
          activeSurge={generalSurge}
        />
      </section>
    </div>
  );
};

export default DeliveryManagmentTable;
